import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable, destroyDataTable } from "../../../custom/dataTable";
import Edit from "../../../../assets/img/svg/edit.svg"
import Delete from '../../../../assets/img/svg/delete.svg';
import FilterIcon from '../../../../assets/img/svg/FilterIcon.svg'
import del from "../../../../assets/img/svg/Del.svg";
import { TextField, InputBase, InputAdornment, IconButton, Checkbox } from '@material-ui/core';
import Autocomplete from "react-autocomplete"
import { useNavigate } from "react-router-dom";
import View from "../../../../assets/img/svg/view.svg"
import download from "../../../../assets/img/svg/DownloadIcon.svg"
import Pagination from "../../../custom/Pagination";
import $ from 'jquery';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import axios from "axios";
import API from "../../../../_helpers/endpointService";
import { getPCPActivity, getPCP_ListView, deletemulitipcpdocs } from "../../../../actions/PCPAction";
import moment from "moment";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { getSettingsFormat } from "../../../../actions/SettingsAction";
import { getlookupdocinfo } from "../../../../actions/MasterDataAction";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
}));
// function groupArrayOfObjects(list, key) {
//     return list.reduce(function (rv, x) {
//         (rv[x[key]] = rv[x[key]] || []).push(x);
//         return rv;
//     }, {});
// };
class ListViewPCP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            ProjectId: 0,
            Sorting: '',
            index: 1,
            DownDelete: [],
            PCP_ListView: [],
            isAccess: false,
            searchData: {
                Activity: '',
                FromDate: '',
                ToDaTe: '',
                PageNumber: 1,
                PageSize: 10,
                SortBy: 'date',
                SortOrder: 'asc'
            }
        }
    }

    componentDidMount() {
        const { dispatch } = this.props;
        (localStorage.getItem("UserRoles") == "Admin" || localStorage.getItem("UserRoles") == "Supervisor") ? this.setState({ isAccess: true }) : this.setState({ isAccess: false })
        this.state.ProjectId = localStorage.getItem("DashId");
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.setState({})
        // dispatch(getPCPActivity())
        this.props.dispatch(getlookupdocinfo("PreCutting"))
        this.getSettingsFormat(this.state.ProjectId)
        localStorage.removeItem("PCPEditId")
        // this.dataTable(this.state.searchData, this.state.ProjectId)
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    getSettingsFormat = (data) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        let apiUrl = API.SETTINGS_PROJECT + data;
        axios({
            method: "get",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                if (response?.status === 200) {
                    this.props.dispatch({ type: "SETTINGS", data: response.data });

                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.dataTable(this.state.searchData, this.state.ProjectId);
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#PRECUT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Precutting1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Precutting").addClass("d-none");
        $("#Precutting").removeClass("d-block");
        $("#PCPL").removeClass("active-color");
        $("#PCPT").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#PRECUT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Precutting1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Precutting").removeClass("d-none");
        $("#Precutting").addClass("d-block");
        $("#PCPL").addClass("active-color");
        $("#PCPT").addClass("fw-bolder");
    }

    dataTable = (data, id) => {
        destroyDataTable("staffTable");
        let apiUrl = API.PCP_LISTVIEW + '?projectId=' + id + '&Activity=' + data.Activity + '&FromDate=' + data.FromDate + '&ToDaTe=' + data.ToDaTe + '&SortBy=' + data.SortBy + '&SortOrder=' + data.SortOrder + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
        // this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,

        })
            .then((response) => {
                if (response?.status === 200) {
                    this.props.dispatch({ type: "PCPLIST_DOCS", data: response.data });
                    applyDataTable("staffTable", "", [{ "orderable": false, "targets": [0], visible: this.state.isAccess === false ? false : true }, { type: 'day', targets: [1] }], "", "", "", this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY",[this.state.index,data.SortOrder]);
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
                else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
            });
    };

    AddNew = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/precuttingprogressreport/addnew")
    };

    EditPage = () => {
        this.props.dispatch({ type: "CANCEL", data: false });
        this.props.navigate("/precuttingprogressreport/edit")
    };

    ViewPage = () => {
        this.props.navigate("/precuttingprogressreport/view")
    };
    ViewPageClick = (id) => {
        localStorage.setItem("PCPViewId", id)
        this.props.navigate("/precuttingprogressreport/view")
    }
    DeleteItem = () => {
        this.deletemulitipcpdocs(this.state.DownDelete, this.state.UserRole)
        $('input[type=checkbox]').prop('checked', false);
    }

    deletemulitipcpdocs = (data, modify) => {
        let ids = "";
        if (data && data.length > 0) {
            data.map((val, index) => {
                if (index == 0) {
                    ids += "ids=" + val;
                }
                else {
                    ids += "&ids=" + val;
                }
            })
        }
        let apiUrl = API.PCP_LISTVIEW + '/ids?' + ids + '&modify=' + modify;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "DELETE",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.DownDelete = [];
                    this.state.searchData = {
                        Activity: '',
                        FromDate: '',
                        ToDaTe: '',
                        PageNumber: 1,
                        PageSize: 10,
                        SortBy: 'date',
                        SortOrder: 'asc'
                    };
                    this.setState({})
                    this.dataTable(this.state.searchData, this.state.ProjectId)
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    }
    renderProjectNames = (state, val) => {
        return state?.Name?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
    };geS
    handleProjectNameSearchChange = (e) => {
        this.state.searchData.Activity = e.target.value;
        this.setState({});
    };
    handleProjectNameSelectChange = (e) => {
        this.state.searchData.Activity = e;
        this.setState({});
    };

    handleCheckbox = (e, x) => {
        const { DownDelete } = this.state;
        if (DownDelete.length == 0) {
            DownDelete.push(x)
        }
        else {
            if (DownDelete.filter((i) => i == x).length == 1) {
                DownDelete.map((i, ind) => (
                    i == x ?
                        DownDelete.splice(ind, 1)
                        : ""
                ))
            } else {
                DownDelete.push(x)
            }
        }
        this.setState({})
        if (DownDelete.length == 1) {
            localStorage.setItem("PCPEditId", DownDelete[0])
            localStorage.setItem("PCPViewId", DownDelete[0])
        }
    }

    BackPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber - 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
    }

    NextPage = () => {
        this.state.searchData.PageNumber = this.state.searchData.PageNumber + 1;
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    handleDateChange = (e, str) => {
        this.state.searchData[str] = e.target.value;
        this.setState({});
    }
    
    Search = () => {
        const { dispatch } = this.props;
        this.state.index=1;
        this.state.searchData.SortBy='date'
        this.state.searchData.SortOrder='asc'
        this.setState({})
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.dataTable(this.state.searchData, this.state.ProjectId);
    }
    ResetFilter() {
        const { dispatch } = this.props;
        const input = {
            Activity: '',
            FromDate: '',
            ToDaTe: '',
            PageNumber: 1,
            PageSize: 10,
            SortBy: 'date',
            SortOrder: 'asc'
        };
        this.state.searchData = input;
        this.setState({});
    }
    handleSort = (data, ind) => {
        if (this.state.searchData.SortBy === data) {
            this.state.searchData.SortOrder = this.state.searchData.SortOrder === "asc" ? "desc" : "asc";
        }
        else {
            this.state.searchData.SortOrder = "asc";
        }
        this.state.searchData.SortBy = data
        this.state.searchData.PageNumber = 1;
        this.setState({
            index: ind,
        });
        this.dataTable(this.state.searchData, this.state.ProjectId);

    }
    render() {
        let { classes, menuToggle, PCPACTIVITY_LOOKUP } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"PRECUT" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="PRECUT" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-2 mt-5">
                                    <h4>Pre Cutting Progress</h4>
                                </div>
                            </div>


                        </>

                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    {this.state.isMobile ?
                        this.state.isAccess ? <>
                            <div className="row  border-bottom ">
                                <div className="input-group">

                                    <div className="col-3 col-sm-3 border-right text-center pt-3" style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${this.state.DownDelete.length == 1 ? "span-enabled" : "span-disabled"}`} onClick={this.ViewPage} style={{ minWidth: '70px' }}><img src={View} style={{ marginTop: '-4px', opacity: this.state.DownDelete.length == 1 ? '' : '0.5' }}></img>&nbsp;View</span>
                                    </div>

                                    <div className=" col-3 col-sm-3 border-right text-center pt-3" style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${(this.state.DownDelete.length == 1 && this.state.isAccess == true) ? "span-enabled" : "span-disabled"}`} onClick={this.EditPage} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: (this.state.DownDelete.length && this.state.isAccess == true) == 1 ? '' : '0.5' }}></img>&nbsp;Edit</span>
                                    </div>
                                    <div className=" col-3 col-sm-3 border-right text-center pt-3 pl-2" style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${(this.state.DownDelete.length > 0 && this.state.isAccess == true) ? "span-enabled" : "span-disabled"}`} data-target="#deletepopup" style={{ minWidth: '60px' }} data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: (this.state.DownDelete.length && this.state.isAccess == true) > 0 ? '' : '0.5' }}></img>&nbsp;Delete</span>
                                    </div>
                                    <div className=" col-3 col-sm-3 pt-3  text-center pb-3 pl-1" style={{ whiteSpace: 'nowrap' }}>
                                        <span className={`${classes.button}`} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? '' : '0.5' }}></i>Add New</span>
                                    </div>
                                </div>
                            </div>
                        </>
                            :
                            <></>
                        : <>
                            {this.state.isAccess ? <>
                                <div className="row  border-bottom">
                                    <div className="col-xl-3  col-md-3 col-lg-3 col-sm-3   d-flex">

                                        <button className={`${classes.button}  pl-3`} onClick={this.ViewPage} disabled={this.state.DownDelete.length == 1 ? false : true} style={{ minWidth: '70px' }}><img src={View} style={{ marginTop: '-4px', opacity: this.state.DownDelete.length == 1 ? '' : '0.5' }}></img>&nbsp;View</button>

                                        <button className={`${classes.button}`} onClick={this.EditPage} disabled={(this.state.DownDelete.length == 1 && this.state.isAccess == true) ? false : true} style={{ minWidth: '70px' }}><img src={Edit} style={{ marginTop: '-4px', opacity: (this.state.DownDelete.length == 1 && this.state.isAccess == true) ? '' : '0.5' }}></img>&nbsp;Edit</button>
                                        <button className={classes.button} data-target="#deletepopup" disabled={(this.state.DownDelete.length > 0 && this.state.isAccess == true) ? false : true} style={{ minWidth: '70px' }} data-toggle="modal"><img src={Delete} style={{ marginTop: '-4px', opacity: (this.state.DownDelete.length > 0 && this.state.isAccess == true) ? '' : '0.5' }}></img>&nbsp;Delete</button>
                                        <div className="col-xl-12 p-3 col-md-12 col-lg-12 col-sm-12  ml-2 border-left">
                                            <button className={classes.button} disabled={this.state.isAccess == true ? false : true} onClick={this.AddNew} style={{ minWidth: '70px' }}><i className="fa fa-plus pr-2" style={{ color: "#00838F", opacity: this.state.isAccess ? '' : '0.5' }}></i>Add New</button>
                                        </div>


                                    </div>
                                </div>
                            </> : <></>}
                        </>
                    }
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">
                            <div className="col-10 pt-2">
                                {this.state.isMobile ? <></> : <h6>Pre Cutting Progress</h6>}
                            </div>
                            <div className="col-2 pt-2">
                                <button data-toggle="modal" data-target="#custom-modal" className={`${classes.button} float-end`} style={{ minWidth: '70px' }}><img src={FilterIcon} />&nbsp;Filter </button>
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div className="table-responsive mb-5" style={{ width: "100%" }}>
                                <table id="staffTable" className="table">
                                    <thead>
                                        <tr className="table-active">
                                            <th className="border-top border-left" width="3%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-top border-right border-left" width="9%" style={{ minWidth: window.innerWidth < 1000 ? '45px' : "" }} onClick={() => this.handleSort('date', 1)}><span className="spandoc-thead" style={{ color: "#000000" }}>Date</span></th>
                                            <th className="border-top border-right" width="20%" style={{ minWidth: window.innerWidth < 1000 ? '250px' : "" }} onClick={() => this.handleSort('activity', 2)}><span className="spandoc-thead" style={{ color: "#000000" }}>Activities</span></th>
                                            <th className="border-top border-right" width="68%" style={{ minWidth: window.innerWidth < 1000 ? '400px' : "" }} onClick={() => this.handleSort('description', 3)}><span className="spandoc-thead" style={{ color: "#000000" }}>Description</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.props.PCP_ListView?.Cutting && this.props.PCP_ListView?.Cutting.map((i) => (<>
                                            <tr>
                                                <td className="spandoc-td align-middle border-left"><input type="checkbox" checked={this.state.DownDelete.filter(r=> r === i.Id).length == 1 ? true : false} style={{ width: "16px", height: "16px" }} onChange={(e) => { this.handleCheckbox(e, i.Id) }} /></td>
                                                <td className="spandoc-td align-middle border-right border-left">{i.Date && moment(i.Date).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}</td>
                                                <td className="spandoc-td align-middle border-right"><a href='#' onClick={() => this.ViewPageClick(i.Id)}>{i.Activity}</a></td>
                                                <td className="spandoc-td align-middle border-right">{i.Description}</td></tr>
                                        </>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="modal left fade pt-5 mt-3" id="custom-modal" tabIndex={-1} role="dialog" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" style={{ width: this.state.isMobile ? "250px" : "" }}>
                            <div className="modal-content border-radius">
                                <div className="modal-header">
                                    <div className="row m-0">
                                        <h6 className="modal-title" id="myCenterModalLabel">Advanced Filter</h6>
                                        <div className="col-12">
                                            <span className="cursorPointer" onClick={() => this.ResetFilter()}>
                                                <img src={FilterIcon} />&nbsp;<span>Reset to default</span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-body p-4">
                                    <form id="myform">
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Activity</label>
                                            </div>
                                            <div className="col-7">
                                                <div className="autocomplete-wrappers">
                                                    <Autocomplete
                                                        contentEditable={true}
                                                        value={this.state.searchData.Activity}
                                                        inputProps={{
                                                            placeholder: "Activity",
                                                        }}
                                                        items={PCPACTIVITY_LOOKUP ?? []}
                                                        getItemValue={(item) => item.Name}
                                                        shouldItemRender={this.renderProjectNames.bind(this)}
                                                        renderMenu={(item) => (
                                                            <div className="dropdowns d-block" >{item}</div>
                                                        )}
                                                        renderInput={(props) => {
                                                            return (
                                                                <input
                                                                    className="form-control border-radius"
                                                                    id="exampleFormControlInput1"
                                                                    {...props}
                                                                    style={{ height: 32, fontSize: 12, color: "#000000" }}
                                                                />
                                                            );
                                                        }}
                                                        renderItem={(item, isHighlighted) => (
                                                            <div
                                                                className={`items 
                                          ${isHighlighted ? "selected-items" : ""
                                                                    }`}
                                                            >
                                                                {item.Name}
                                                            </div>
                                                        )}
                                                        onChange={(e) => this.handleProjectNameSearchChange(e)}
                                                        onSelect={(e) => this.handleProjectNameSelectChange(e)}
                                                    />
                                                </div>
                                            </div>
                                        </div><div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - From</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    value={this.state.searchData.FromDate && moment(this.state.searchData.FromDate).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.FromDate && moment(this.state.searchData.FromDate).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "FromDate") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-5 m-auto">
                                                <label htmlFor="name">Date - To</label></div>
                                            <div className="col-7">
                                                <input
                                                    id="type-date1"
                                                    type="date"
                                                    max={JSON.parse(localStorage.getItem('BasicInfo')) && (JSON.parse(localStorage.getItem('BasicInfo')).Status.toLowerCase() == 'completed' ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectCompletionDate).format("yyyy-MM-DD") : JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate != null ? moment(JSON.parse(localStorage.getItem('BasicInfo')).ExtensionDate).format("yyyy-MM-DD") : moment(JSON.parse(localStorage.getItem('BasicInfo')).EstimatedCompletionDate).format("yyyy-MM-DD"))}
                                                    min={JSON.parse(localStorage.getItem('BasicInfo')) && moment(JSON.parse(localStorage.getItem('BasicInfo')).ProjectStartDate).format("yyyy-MM-DD")}
                                                    value={this.state.searchData.ToDaTe && moment(this.state.searchData.ToDaTe).format("yyyy-MM-DD")}
                                                    placeholder={this.state.searchData.ToDaTe && moment(this.state.searchData.ToDaTe).format(this.props.settings.Convention ? this.props.settings.Convention : "DD/MM/YYYY")}
                                                    onChange={(e) => { this.handleDateChange(e, "ToDaTe") }}
                                                    style={{ fontSize: 12, height: "38px" }}
                                                    className='form-control border-radius'
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="row text-center mt-4">
                                            {this.state.isMobile ? <></> : <div className="col-2"></div>}
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" className={`btn btn-primary input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`} data-toggle="modal" style={{ backgroundColor: "#00838F", color: "#FFFFFF" }} onClick={() => this.Search()}>Search</button>
                                            </div>
                                            <div className={this.state.isMobile ? "col-6" : "col-5"} data-dismiss="modal">
                                                <button type="button" id="closemodal" className={`btn btn-light input-group border-radius f-size-13 ${this.state.isMobile ? " filter-Mobilebtn" : "filter-btn"}`}>Cancel</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div >
                    <div class="modal fade p-5 mt-5" id="deletepopup" tabindex="-1" role="dialog" aria-labelledby="deletepopupLabel" aria-hidden="true" style={{ top: "13%", left: this.state.isMobile ? "2%" : menuToggle ? "10%" : "" }}>
                        <div class="modal-dialog" role="document">
                            <div class={this.state.isMobile ? "modal-content" : "modal-content p-3"}>
                                <div class="modal-body pb-0">
                                    <h1 className="text-center">
                                        <img src={del}></img>
                                    </h1>
                                    <div className="text-center">
                                        <h5 class="fw-bold">Are you sure you want to delete?</h5> </div>
                                </div>
                                <div class="modal-footer border-top-0 m-auto">
                                    <button type="button" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#00838F", border: "none" }} onClick={this.DeleteItem}><span className="" >Delete</span></button>
                                    <button type="button" id="closemodal1" class={this.state.isMobile ? "btn btn-secondary" : " btn btn-secondary py-2 px-4"} data-dismiss="modal" style={{ backgroundColor: "#EBEBEB", border: "none", color: "#111010" }}><span className="" >Cancel</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${classes.pagination}`}>
                    <div className={`${classes.paginationItem}`}>
                        {this.state.searchData.PageNumber == 1 ? <></> :
                            <ArrowBackIcon className={classes.arrow} onClick={() => this.BackPage()} />}
                        <span className="pl-2 pr-2">Page {this.state.searchData.PageNumber}</span>
                        {(this.state.searchData.PageNumber == this.props.PCP_ListView?.pagination?.PageCount) || (this.props.PCP_ListView?.pagination?.PageCount == 0) ? <></> :
                            <ArrowForwardIcon className={classes.arrow} onClick={() => this.NextPage()} />}
                    </div>
                </div>
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        PCP_ListView: state.PCPReducer.PCP_ListView || [],
        PCPACTIVITY_LOOKUP: state.MasterDataReducer.Lookup_data || [],
        settings: state.commonReducer.settings || [],
    };
}

ListViewPCP.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewPCP))
);
